import * as React from 'react';
import * as PropTypes from 'prop-types';
import Counter from '../Cnt10';
import { ElementWrapper, CounterText, ContentText } from './elements';

type Lab114Props = {
  onClick?: () => void;
  className?: string;
  theme?: 'light' | 'dark';
  animation?: boolean;
  decimals?: string | number;
  locale: string;
  number?: string | number;
  textcontent?: string;
};

function Lab114(props: Lab114Props): React.ReactElement {
  return (
    <ElementWrapper onClick={props.onClick} className={props.className}>
      <CounterText $themeName={props.theme}>
        {props.animation ? (
          <Counter decimals={props.decimals} animate locale={props.locale}>
            {props.number}
          </Counter>
        ) : (
          props.number
        )}
      </CounterText>
      <ContentText $themeName={props.theme}>{props.textcontent}</ContentText>
    </ElementWrapper>
  );
}

Lab114.propTypes = {
  animation: PropTypes.bool,
  className: PropTypes.string,
  decimals: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClick: PropTypes.func,
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  textcontent: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  locale: PropTypes.string.isRequired,
};
export default Lab114;
